module.exports = __webpack_public_path__ + "img/news.953b9197.jpg";